// import { icons } from './icons.js';

export async function install_plugin(name) {
    switch (name) {
        case 'admin': {
                await Graphite.import('admin');
            }

            break;

        case 'icons': {
                if (Graphite.icons) return;
                
                let icons = await Graphite.import('icons');            
                
                if (icons) {
                    Graphite.icons = icons;
                }
            }

            break;

        case 'zen-editor': {
                if (Graphite.zen_editor) return;

                let ZenEditor = await Graphite.import('zen-editor');            
                
                if (ZenEditor) {
                    Graphite.zen_editor = new ZenEditor();
                }
            }

            break;

        case 'shopping-cart': {
                if (Graphite.shopping_cart) return;

                let ShoppingCart = await Graphite.import('shopping-cart');

                if (ShoppingCart) {
                    Graphite.shopping_cart = new ShoppingCart();
                }
            }

            break;

        case 'ejs': {
                if (Graphite.ejs) return;

                let ejs = await Graphite.import('ejs');

                if (ejs) {
                    Graphite.ejs = ejs;
                }
            }

            break;

        case 'tippy': {
                if (Graphite.tippy) return;

                let Tippy = await Graphite.import('tippy');

                if (Tippy) {
                    Graphite.tippy = new Tippy();
                }
            }

            break;

        case 'masonry': {
                if (Graphite.masonry) return;

                let masonry = await Graphite.import('masonry');

                if (masonry) {
                    Graphite.masonry = masonry;
                }
            }

            break;

        case 'grid-layout': {
                if (Graphite.grid_layout) return;

                let grid_layout = await Graphite.import('grid-layout');

                if (grid_layout) {
                    Graphite.grid_layout = grid_layout;
                }
            }

            break;

        case 'qrcode': {
                if (Graphite.qrcode) return;

                let qrcode = await Graphite.import('qrcode');

                if (qrcode) {
                    Graphite.qrcode = qrcode;
                }
            }

            break;

        case 'widgets-dialog': {
                if (Graphite.select_widget) return;

                let select_widget = await Graphite.import('widgets-dialog');

                if (select_widget) {
                    Graphite.select_widget = select_widget;
                }
            }

            break;

        case 'open-map': {
                if (Graphite.OpenMap) return;

                let OpenMap = await Graphite.import('open-map');

                if (OpenMap) {
                    Graphite.OpenMap = OpenMap;
                }
            }

            break;

        case 'swiper': {
                if (Graphite.swiper) return;

                let swiper = await Graphite.import('swiper');

                if (swiper) {
                    Graphite.swiper = swiper;
                }
            }

            break;

        case 'photoswipe': {
                if (Graphite.photoswipe) return;

                let photoswipe = await Graphite.import('photoswipe');

                if (photoswipe) {
                    Graphite.photoswipe = photoswipe;
                }
            }

            break;

        case 'dotlottie': {
                if (Graphite.DotLottie) return;

                let DotLottie = await Graphite.import('dotlottie');

                if (DotLottie) {
                    Graphite.DotLottie = DotLottie;
                }
            }

            break;
    }
}